export default __webpack_public_path__ + "static/media/orderbook_navicon copy.214abf69.svg";